// extracted by mini-css-extract-plugin
export default {"item":"MainAccordion_item__C7ITP","button":"MainAccordion_button__thxas","content":"MainAccordion_content__rqK8x"};